import Vue from "vue"
import VueRouter from "vue-router"

Vue.use(VueRouter)

const routes = [
	{
		path: "/login",
		name: "Login",
		component: () => import("../views/Login.vue")
	},
	{
		path: "/",
		name: "Home",
		component: () => import("../views/Tasks.vue")
	},
	{
		path: "/tasks",
		name: "Tasks",
		component: () => import("../views/Tasks.vue")
	}
]

const router = new VueRouter({
	mode: "history",
	base: process.env.BASE_URL,
	routes
})

export default router
